import React from 'react';
import { useSearchParams } from 'react-router-dom';

const REASON_MESSAGES = {
  invalid_state:
    'Your login session expired, or this link has already been used. Please try logging in again from the start.',
  consent_denied:
    'You declined the requested permissions. Please try again and accept the permissions to continue.',
  token_validation_failed:
    "There's a configuration problem with your account. Please contact support — retrying alone won't fix this.",
  user_not_found:
    'No account was found for your email address. Please complete onboarding first, or contact support if you believe this is a mistake.',
  server_error:
    'An unexpected error occurred on our end. Please try again. If the problem persists, contact support.',
  invalid_request:
    'Invalid sign-in request. The link may be incomplete or expired. Please return to the app and try again.',
};

/**
 * Route: /admin-grant/error
 *
 * Public page rendered before keycloak.init() runs, so it's reachable without
 * a valid session. Reads ?reason=<code> from the query string and maps it to a
 * human-readable message. The five valid codes come from the Microsoft OAuth
 * callback in supply-core (KAVC-2076).
 */
const AuthErrorPage = () => {
  const [searchParams] = useSearchParams();
  const reason = searchParams.get('reason') || '';
  const message = REASON_MESSAGES[reason] || "We couldn't log you in.";

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        backgroundColor: '#f5f5f5',
      }}
    >
      <div
        style={{
          textAlign: 'center',
          padding: '48px',
        }}
      >
        <h1
          style={{
            fontSize: '24px',
            fontWeight: '600',
            color: '#1a1a1a',
            marginBottom: '16px',
            margin: '0 0 16px',
          }}
        >
          Something went wrong
        </h1>
        {reason && (
          <p style={{ margin: '0 0 12px', maxWidth: '420px' }}>
            Error code:{' '}
            <code
              style={{
                fontSize: '13px',
                fontFamily: 'monospace',
                color: '#c0392b',
                backgroundColor: '#fdf2f0',
                padding: '2px 6px',
                borderRadius: '3px',
              }}
            >
              {reason}
            </code>
          </p>
        )}
        <p
          style={{
            fontSize: '16px',
            color: '#666666',
            margin: '0 0 16px',
            maxWidth: '420px',
          }}
        >
          {message}
        </p>
        <p
          style={{
            fontSize: '16px',
            color: '#666666',
            margin: 0,
            maxWidth: '420px',
          }}
        >
          Please contact the QAD Persona Agent team for assistance.
        </p>
      </div>
    </div>
  );
};

export default AuthErrorPage;
